import type {
    CustomTranslationStatusesResponse,
    GetTranslationSuggestionsResponse,
    SetToggleCompleteItemResponse,
    TaskItemStatus,
    UpdateTranslationReviewedResponse,
} from '.';

/* eslint-disable @typescript-eslint/naming-convention */
type TransformToggleCompleteItemResponseProps = {
    changed: boolean;
    closed_language: Record<string, never> | null;
    closed_task: Record<string, never> | null;
    status: TaskItemStatus;
    success: boolean;
    task_id: number;
    task_item_id: number;
};

type TransformUpdateTranslationReviewedResponseProps =
    | { err: '0' | 1 }
    | {
          err: 0;
          proofread: boolean;
          task_autocomplete_data: null | TransformToggleCompleteItemResponseProps;
          akey_id: number;
      };
/* eslint-enable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/naming-convention */
type CustomTranslationStatusesResponseProps = {
    ids: number[];
    translation_id: string;
    task_autocomplete_data: TransformToggleCompleteItemResponseProps | null;
};

type GetTranslationSuggestionsProps = Omit<GetTranslationSuggestionsResponse, 'task' | 'inline_data'> & {
    task: {
        id: number;
        source_lang_id: number;
    };
    inline_data: GetTranslationSuggestionsResponse['inlineData'];
};

export const transformToggleCompleteItemResponse = (
    response: TransformToggleCompleteItemResponseProps,
): SetToggleCompleteItemResponse => ({
    changed: response.changed,
    closedLanguage: response.closed_language,
    closedTask: response.closed_task,
    status: response.status,
    success: response.success,
    taskId: response.task_id,
    taskItemId: response.task_item_id,
});

export const transformUpdateTranslationReviewedResponse = (
    response: TransformUpdateTranslationReviewedResponseProps,
): UpdateTranslationReviewedResponse => {
    if (!('proofread' in response)) {
        return response;
    }

    return {
        err: response.err,
        proofread: response.proofread,
        akeyId: response.akey_id,
        taskAutocompleteData: response.task_autocomplete_data
            ? transformToggleCompleteItemResponse(response.task_autocomplete_data)
            : response.task_autocomplete_data,
    };
};

export const transformCustomTranslationStatusesResponse = (
    response: CustomTranslationStatusesResponseProps,
): CustomTranslationStatusesResponse => ({
    taskAutoCompleteData: response.task_autocomplete_data
        ? transformToggleCompleteItemResponse(response.task_autocomplete_data)
        : response.task_autocomplete_data,
    translationId: response.translation_id,
    ids: response.ids,
});

export const transformGetSuggestionsResponse = (
    response: GetTranslationSuggestionsProps,
): GetTranslationSuggestionsResponse => {
    const data: GetTranslationSuggestionsResponse = {
        err: response.err,
        task: response.task ? { id: response.task.id, sourceLanguageId: response.task.source_lang_id } : null,
        ai: response.ai,
    };

    if (response.base) {
        data.base = response.base;
    }

    if (response.inline_data) {
        data.inlineData = response.inline_data;
    }

    return data;
};
